import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import PlayButton from "./PlayButton";
import PauseButton from "./PauseButton";
import SettingsButton from "./SettingsButton";
import SettingsContext from "./SettingsContext";
import {useContext, useState, useEffect, useRef} from "react";
import RestartButton from "./RestartButton";

const yellow = "#fffae8";
const red = "#d46a6a";
const green = "#6bcB77";

function Timer() {  
    const settingsInfo = useContext(SettingsContext);
    const [isRunning, setIsRunning] = useState(false);
    const [mode, setMode] = useState("work"); // work, break, null
    const [timeLeft, setTimeLeft] = useState(0);

    const timeLeftRef = useRef(timeLeft);
    const isRunningRef = useRef(isRunning);
    const modeRef = useRef(mode);
    const settingsInfoRef = useRef(settingsInfo);

    function initWorkTimer(){
        setTimeLeft(settingsInfo.workMinutes * 60);
        timeLeftRef.current = settingsInfo.workMinutes * 60;
        setMode("work");
        modeRef.current = "work";
    }

    function switchMode(){
        const nextMode = modeRef.current === "work" ? "break" : "work";
        const nextTimeLeft = (nextMode === "work" ? settingsInfoRef.current.workMinutes : settingsInfoRef.current.breakMinutes) * 60;
        console.log("Switching to " + nextMode + " for " + nextTimeLeft + " seconds.");
        console.log(settingsInfoRef.current.breakMinutes);
        setMode(nextMode);
        modeRef.current = nextMode;

        setTimeLeft(nextTimeLeft);
        timeLeftRef.current = nextTimeLeft;
    }

    function tick(){
        timeLeftRef.current--;
        setTimeLeft(timeLeftRef.current);      
    }

    useEffect(() => {
        if(modeRef.current === "work"){
            setTimeLeft(settingsInfo.workMinutes * 60);
            timeLeftRef.current = settingsInfo.workMinutes * 60;
            setMode("work");
            modeRef.current = "work";
        }
    }, [settingsInfo.workMinutes]);

    useEffect(() => {
        if(modeRef.current === "break"){
            setTimeLeft(settingsInfo.breakMinutes * 60);
            timeLeftRef.current = settingsInfo.breakMinutes * 60;
        }
    }, [settingsInfo.breakMinutes]);

    useEffect(() => {
        settingsInfoRef.current = settingsInfo;
    }, [settingsInfo]);

    useEffect(() => {
        const timer = setInterval(() => {
        if(!isRunningRef.current) return;

        if(timeLeftRef.current === 0){
            return switchMode();
        }
        tick();
        
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    let percentage = Math.round((timeLeft / (mode === "work" ? settingsInfo.workMinutes * 60 : settingsInfo.breakMinutes * 60)) * 100);
    let minutes = Math.floor(timeLeft  / 60);
    let seconds = timeLeft % 60;
    if(seconds < 10){
        seconds = "0" + seconds;
    }

    return (
        <div>
            <div style={{width: '300px', margin: '0 auto'}}>
                <CircularProgressbar value={percentage} text={minutes + ":" + seconds} styles={buildStyles({
                    pathColor: mode === "work" ? red : green,
                    textColor: yellow,
                })}/>
            </div>
            <div style={{marginTop:'20px'}}>
                {isRunning? <PauseButton onClick={() => {setIsRunning(false); isRunningRef.current = false;}}/> : <PlayButton onClick={() => {setIsRunning(true); isRunningRef.current = true;}}/>}  
                <RestartButton onClick={() => {initWorkTimer(); setIsRunning(false); isRunningRef.current = false;}}/>
            </div>
            <div style={{marginTop:'20px'}}>
                <SettingsButton onClick={() => {settingsInfo.setShowSettings(!settingsInfo.showSettings)}}/>
            </div>
        </div>
    )
}

export default Timer;